import styled from "styled-components";
import ArrowLeftImg from "@/assets/svg/ArrowLeft.svg";
import SuccessImg from "@/assets/svg/success.svg";

import { ReactSVG } from "react-svg";
import { useState } from "react";

import BTCCImg from '@/assets/imgs/btc.png'
import ETHCImg from '@/assets/imgs/eth.png'
import LINKImg from '@/assets/imgs/link.png'


export default function Trade({ handleClose, selectToken, currentToken }) {

  const [index, setIndex] = useState(null)

  const list = [{
    address:'',
    name:'jBTC 5x',
    desc:'Bitcoin'
  },{
    address:'',
    name:'jETH 5x',
    desc:'ETH coin'
  },
  {
    address:'',
    name:'jLINK 5x',
    desc:'Chainlink'
  },]

  const handleClick = (idx)=>{
    setIndex(idx)
    selectToken(list[idx])
    handleClose()    
  }
  
  return (
    <Modal>      
      <div className='close' onClick={handleClose}><ReactSVG src={ArrowLeftImg}/></div>
      <div className="content">   
        <div className="title">Select a token</div>
        <div className="tokens-list">
          {
            list.map((item, idx) =><div key={idx} className="token-dl" onClick={() => handleClick(idx)}>
              <div className='flex-1 token-item'>
                <img className="token-logo" src={!idx ? BTCCImg : ( idx === 1 ? ETHCImg : LINKImg )} alt="" />
                <div className='token'>
                  <div className='token-title'>{item.name}</div>
                  <div className='token-desc'>{item.desc}</div>
                </div>
              </div>
              { currentToken.symbol === item.name && <ReactSVG src={SuccessImg}/> }
            </div> )
          }
        </div>
      </div>
    </Modal>
  );
}

const Modal = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  .close {
    position: absolute;
    left: 37px;
    top: 37px;
    cursor: pointer;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 29px 35px;
    .tokens-list{
      width: 100%;
    }
    .title {
      padding-bottom:24px;
      font-weight: 600;
      font-size: 24px;
      line-height: 34px;
      color: #32DE86;
    }
      .flex-1{
        flex: 1;
      }
      .token-dl{
        display: flex;      
        justify-content: space-between;
        align-items: center;
        padding: 17px 18px 15px 10px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        cursor: pointer;
        & + .token-dl{
          margin-top:12px;
        } 
      }
    .token-item{
      display: flex;      
      align-items: center;
      .token-logo{
        width: 36px;
        height: 36px;
        border-radius:52%;
        margin-right:17px;
      }
    }
    .token{
      display: flex;
      flex-direction: column;      
      .token-title{        
        font-size: 16px;
        line-height: 24px;
      }
      .token-desc{
        font-size: 14px;
        color: #737373;
        line-height: 18px;
        padding-top: 1px;
      }
    }
    
  }

  @keyframes rotate{
   from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
  .noop{
    height:20px;
  }
  .spinner{
    margin-top: 40px;
    width: 30px;
    height: 30px;    
    animation: 2s rotate linear infinite;
  }
  .approve-text{
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #fff;
  }

`;
